import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConnectedContentCredentials = lazy(() =>
  import("@scenes/ConnectedContentCredentials").then((module) => ({
    default: module.default.ConnectedContentCredentials,
  }))
);

export const connectedContentNRO: NavigationRoutingObject = {
  Component: ConnectedContentCredentials,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("connected-content-menu-option", "Connected Content"),
  getDeveloperNavigationAllowed: ({ hasPermission }) => hasPermission("appGroup", { permission: "manageAppGroup" }),
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("connected-content-alt-keyword-1", "Authentication Credentials")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
